/* 
    Información que tiene el objeto de fechas
         fechas.Add(itemfecha.fecha + '|'+ itemfecha.detalle + '|' + itemfecha.quincenal + '|' + itemfecha.cc); 
*/

import React, {useState, useEffect} from "react";
import "./../Feeds/style.css";
import './../Estilos/Bootstrap/bootstrap.css';
import axios from "axios";

export default function Feeds(){
    const rutadoc=process.env.REACT_APP_RUTA_DOC;
    const servpreprod= process.env.REACT_APP_SERVIDOR;
    const rutaIndicadores= process.env.REACT_APP_URL_INDICADORES;

    const [feeds, setFeeds]= useState([]);
    const [feedsDia, setFeedsDia]= useState([]);
    const [idioma, setIdioma]= useState([]);
    const [fila1,setFila1]= useState([]);
    const [fila2,setFila2]= useState([]);
    const [loading,setLoading]= useState(false);
    const [calendario, setCalendario]= useState([]);
    const [nemonicos, setNemonicos]= useState([]);



    //let indicePrecios=["INPCAC_M_O","INPCAS_M_O","INPCA_M_O","INPCVS_Q_O","INPCV_Q_O","INPCMS_M_O","INPCACS_M_O","INPCM_M_O","INPCVI_Q_O","INPCVSI_Q_O"];
   
    useEffect(() => { 
        setLoading(true);
        let pathname = window.location.href;
        let apiURL= "";
        let nemonicos=[];
        let resServicioAgrup=[];
        let resServicioAgrup2=[];
        let nemonico_cd="";
        let nemonico_co="";
        let no_prog="";
        let serie_cd="";
        let serie_co="";
        let serie_var="";
        let ultimo_dato={};
        let fechaActual= new Date;
        const obtenerDatos = async () => {
        try{
            //servicio Susi
            let resServicio=[];
            let resServicioHoy=[];
            let banIdioma="es";
            //Publicaciones del día
            //resServicioHoy= await axios.get('/app/api/saladeprensa/api/saladeprensa/feeds/calendario/hoy');
            resServicio = await axios.get('/app/api/saladeprensa/api/saladeprensa/feeds/calendario/siguientes');
            if (pathname.indexOf("en.") > -1){
                banIdioma="en";
            }
            else{
                banIdioma="es";
            }
            //lectura del json de nemónicos
            const resNemonicos = await axios.get('./AgenciasNoticiasNemonicos.json');
            //Servicio publicaciones del día
            /* resServicioHoy.data.map((rs)=>{
                if(resNemonicos.data.findIndex((nm)=>nm.nemNoGrafica===rs.programa)>-1){
                    if(resServicioAgrup2.findIndex((rsa)=>rsa.no_programa===rs.programa)===-1){
                        let filtroS= resServicioHoy.data.filter((rn2)=>rn2.programa===rs.programa);
                        let filtroNT= resNemonicos.data.filter((rn2)=>rn2.nemNoGrafica===rs.programa && rn2.nemIdNemonic.includes("_" + rs.periodicidad));
                        if(filtroNT.length>0){
                            filtroNT.map((fnt)=>{fnt.agregado=false;})
                            let filtroN= resNemonicos.data.filter((rn2)=> rn2.nemIdNemonic!=="IMMEX_M"? rn2.nemIdNemonic.includes("_O") && rn2.nemNoGrafica===rs.programa: rn2.nemNoGrafica===rs.programa );
                            //nemonicos con _O
                            if(filtroN.length>0){
                                let fechas=[];
                                filtroS.map((fs,indexfs)=>{
                                    fechas.push(fechaActual.toLocaleDateString('en-GB') + "|" + fs.detalle + "|" + fs.periodicidad + "|" + fs.cc);
                                })
                                filtroN.map((fn)=>{
                                    let indFlN= filtroNT.findIndex((ifn)=>ifn.nemIdNemonic===fn.nemIdNemonic);
                                    filtroNT[indFlN].agregado=true;
                                    if(nemonicos.findIndex((nm)=>nm===fn.nemIdNemonic)===-1){
                                        nemonicos.push(fn.nemIdNemonic);
                                        nemonico_cd="";
                                        nemonico_co=fn.nemIdNemonic;
                                        no_prog=fn.nemNoGrafica;
                                        serie_cd="";
                                        serie_co=fn.nemClaveSerie;
                                        serie_var= fn.nemCveSerieVariacion;
                                        //Se busca si tiene serie desestacionalizadas _D
                                        let nmco=fn.nemIdNemonic.substring(0, fn.nemIdNemonic.lastIndexOf("_"));
                                        let filtro2= resNemonicos.data.filter((rn3)=>rn3.nemNoGrafica===fn.nemNoGrafica && rn3.nemIdNemonic===nmco + "_D");
                                        if(filtro2.length>0){
                                            let indFlN= filtroNT.findIndex((ifn)=>ifn.nemIdNemonic===nmco + "_D");
                                            filtroNT[indFlN].agregado=true;
                                            nemonicos.push(nmco + "_D");
                                            nemonico_cd=filtro2[0].nemIdNemonic;
                                            serie_cd=filtro2[0].nemClaveSerie;
                                        }
                                        ultimo_dato={};
                                        ultimo_dato={
                                        "nemonico_cifras_desestacionalizadas":nemonico_cd,
                                        "nemonico_cifras_originales":nemonico_co,
                                        "no_programa":no_prog,
                                        "serie_cifras_desestacionalizadas":serie_cd,
                                        "serie_cifras_originales":serie_co,
                                        "serie_variacion":serie_var
                                        }
                                        resServicioAgrup2.push({"fechas":fechas,"indicador":banIdioma==="es"?fn.Descripcion.español:fn.Descripcion.ingles,"periodicidad":banIdioma==="es"?fn.Frecuencia.español:fn.Frecuencia.ingles,"ultimo_dato":ultimo_dato,"no_programa":no_prog});
                                    }
                                }) 
                            }
                            //Se revisa si hay nemónicos que no se agregaron por que no tienen la terminación _O
                            if(filtroNT.filter((fntf)=>fntf.agregado===false).length>0){
                                let filtroNT2= filtroNT.filter((fntf2)=>fntf2.agregado===false);
                                filtroNT2.map((fn)=>{
                                    let fechas=[];
                                    filtroS.map((fs,indexfs)=>{
                                        if(fechas.findIndex((fe)=>fe.split("|")[0]===fs.fecha)===-1){
                                            fechas.push(fs.fecha + "|" + fs.detalle + "|" + fs.periodicidad + "|" + fs.cc);
                                        }
                                    })
                                    if(nemonicos.findIndex((nm)=>nm===fn.nemIdNemonic)===-1){
                                        nemonicos.push(fn.nemIdNemonic);
                                        nemonico_cd="";
                                        nemonico_co="";
                                        no_prog=fn.nemNoGrafica;
                                        serie_cd="";
                                        serie_co="";
                                        serie_var= fn.nemCveSerieVariacion;
                                        nemonico_cd=fn.nemIdNemonic;
                                        serie_cd=fn.nemClaveSerie;
                                        ultimo_dato={};
                                        ultimo_dato={
                                            "nemonico_cifras_desestacionalizadas":nemonico_cd,
                                            "nemonico_cifras_originales":nemonico_co,
                                            "no_programa":no_prog,
                                            "serie_cifras_desestacionalizadas":serie_cd,
                                            "serie_cifras_originales":serie_co,
                                            "serie_variacion":serie_var
                                        }; 
                                        resServicioAgrup2.push({"fechas":fechas,"indicador":banIdioma==="es"?fn.Descripcion.español:fn.Descripcion.ingles,"periodicidad":banIdioma==="es"?fn.Frecuencia.español:fn.Frecuencia.ingles,"ultimo_dato":ultimo_dato,"no_programa":no_prog});
                                    }
                                })
                            }
                        }
                        
                    }
                }
            })
            let resTemp2=JSON.parse(JSON.stringify(resServicioAgrup2)); */
            //Servicio próximas publicaciones
            //generar el objeto final
            nemonicos=[];
            resServicio.data.map((rs)=>{
                if(resNemonicos.data.findIndex((nm)=>nm.nemNoGrafica===rs.programa)>-1){
                    if(resServicioAgrup.findIndex((rsa)=>rsa.no_programa===rs.programa)===-1){
                        let filtroS= resServicio.data.filter((rn2)=>rn2.programa===rs.programa);
                        let filtroNT= resNemonicos.data.filter((rn2)=>rn2.nemNoGrafica===rs.programa);
                        filtroNT.map((fnt)=>{fnt.agregado=false;})
                        let filtroN= resNemonicos.data.filter((rn2)=> rn2.nemIdNemonic!=="IMMEX_M"? rn2.nemIdNemonic.includes("_O") && rn2.nemNoGrafica===rs.programa: rn2.nemNoGrafica===rs.programa );
                        //nemonicos con _O
                        if(filtroN.length>0){
                            let fechas=[];
                            filtroS.map((fs,indexfs)=>{
                                 if(fechas.findIndex((fe)=>fe.split("|")[0]===fs.fecha)===-1){
                                 fechas.push(fs.fecha + "|" + fs.detalle + "|" + fs.periodicidad + "|" + fs.cc);
                                }
                            })
                            filtroN.map((fn)=>{
                                let indFlN= filtroNT.findIndex((ifn)=>ifn.nemIdNemonic===fn.nemIdNemonic);
                                filtroNT[indFlN].agregado=true;
                                if(nemonicos.findIndex((nm)=>nm===fn.nemIdNemonic)===-1){
                                    nemonicos.push(fn.nemIdNemonic);
                                    nemonico_cd="";
                                    nemonico_co=fn.nemIdNemonic;
                                    no_prog=fn.nemNoGrafica;
                                    serie_cd="";
                                    serie_co=fn.nemClaveSerie;
                                    serie_var= fn.nemCveSerieVariacion;
                                    //Se busca si tiene serie desestacionalizadas _D
                                    let nmco=fn.nemIdNemonic.substring(0, fn.nemIdNemonic.lastIndexOf("_"));
                                    let filtro2= resNemonicos.data.filter((rn3)=>rn3.nemNoGrafica===fn.nemNoGrafica && rn3.nemIdNemonic===nmco + "_D");
                                    if(filtro2.length>0){
                                        let indFlN= filtroNT.findIndex((ifn)=>ifn.nemIdNemonic===nmco + "_D");
                                        filtroNT[indFlN].agregado=true;
                                        nemonicos.push(nmco + "_D");
                                        nemonico_cd=filtro2[0].nemIdNemonic;
                                        serie_cd=filtro2[0].nemClaveSerie;
                                    }
                                    ultimo_dato={};
                                    ultimo_dato={
                                    "nemonico_cifras_desestacionalizadas":nemonico_cd,
                                    "nemonico_cifras_originales":nemonico_co,
                                    "no_programa":no_prog,
                                    "serie_cifras_desestacionalizadas":serie_cd,
                                    "serie_cifras_originales":serie_co,
                                    "serie_variacion":serie_var
                                    }
                                    resServicioAgrup.push({"fechas":fechas,"indicador":banIdioma==="es"?fn.Descripcion.español:fn.Descripcion.ingles,"periodicidad":banIdioma==="es"?fn.Frecuencia.español:fn.Frecuencia.ingles,"ultimo_dato":ultimo_dato,"no_programa":no_prog});
                                }
                            }) 
                        }
                        //Se revisa si hay nemónicos que no se agregaron por que no tienen la terminación _O
                        if(filtroNT.filter((fntf)=>fntf.agregado===false).length>0){
                            let filtroNT2= filtroNT.filter((fntf2)=>fntf2.agregado===false);
                            filtroNT2.map((fn)=>{
                                let fechas=[];
                                filtroS.map((fs,indexfs)=>{
                                    if(fechas.findIndex((fe)=>fe.split("|")[0]===fs.fecha)===-1){
                                        fechas.push(fs.fecha + "|" + fs.detalle + "|" + fs.periodicidad + "|" + fs.cc);
                                     }
                                })
                                if(nemonicos.findIndex((nm)=>nm===fn.nemIdNemonic)===-1){
                                    nemonicos.push(fn.nemIdNemonic);
                                    nemonico_cd="";
                                    nemonico_co="";
                                    no_prog=fn.nemNoGrafica;
                                    serie_cd="";
                                    serie_co="";
                                    serie_var= fn.nemCveSerieVariacion;
                                    nemonico_cd=fn.nemIdNemonic;
                                    serie_cd=fn.nemClaveSerie;
                                    ultimo_dato={};
                                    ultimo_dato={
                                        "nemonico_cifras_desestacionalizadas":nemonico_cd,
                                        "nemonico_cifras_originales":nemonico_co,
                                        "no_programa":no_prog,
                                        "serie_cifras_desestacionalizadas":serie_cd,
                                        "serie_cifras_originales":serie_co,
                                        "serie_variacion":serie_var
                                    }; 
                                    resServicioAgrup.push({"fechas":fechas,"indicador":banIdioma==="es"?fn.Descripcion.español:fn.Descripcion.ingles,"periodicidad":banIdioma==="es"?fn.Frecuencia.español:fn.Frecuencia.ingles,"ultimo_dato":ultimo_dato,"no_programa":no_prog});
                                }
                            })
                        }
                    }
                }
            });
            //console.log("resServicioAgrup",resServicioAgrup);
            if (pathname.indexOf("en.") > -1){
                apiURL= process.env.REACT_APP_SERV_URL_ING_TRUE;
                if (pathname.indexOf("/false/") > -1){
                    apiURL= process.env.REACT_APP_SERV_URL_ING_FALSE;
                }
                axios.get("./Idioma/idioma.json")
                .then(function(res){
                    setIdioma(res.data.ing);
                    setFila1(res.data.col1Ing);
                    setFila2(res.data.col2Ing);
                })
                .catch((error) => {
                console.log(error);
                });
            }
            else{
                apiURL= process.env.REACT_APP_SERV_URL_ESP_TRUE;
                if (pathname.indexOf("/false/") > -1){
                    apiURL= process.env.REACT_APP_SERV_URL_ESP_FALSE;
                }
                axios.get("./Idioma/idioma.json")
                    .then(function(res){
                        setIdioma(res.data.esp);
                        setFila1(res.data.col1Esp);
                        setFila2(res.data.col2Esp);
                    })
                    .catch((error) => {
                    console.log(error); 
                });
            }
            resServicioAgrup.map((r)=>{
               r.fechas = r.fechas.sort((a,b)=> new Date(...a.substring(0,10).split('/').reverse()) - new Date(...b.substring(0,10).split('/').reverse()));
            })
            let contfec=0;
            let resTemp=JSON.parse(JSON.stringify(resServicioAgrup));
            resTemp.map((r)=>{
                r.mostrar=true;
                contfec=0;
                let nemonicos= [];
                if (r.ultimo_dato.nemonico_cifras_desestacionalizadas!==""){
                    nemonicos.push(r.ultimo_dato.nemonico_cifras_desestacionalizadas);
                }
                if (r.ultimo_dato.nemonico_cifras_originales!==""){
                    nemonicos.push(r.ultimo_dato.nemonico_cifras_originales);
                }
                let fechas= [];
                r.fechas.map((fc)=>{
                    let banFec=false;
                    for (let i=0; i<nemonicos.length; i++){
                        if ((fc.split("|")[2] === "") || (nemonicos[i].trim().includes("_" + fc.split("|")[2])) || (fc.split("|")[2] === "M" && nemonicos[i].trim().includes("_Q")) || (fc.split("|")[2] == "T" && nemonicos[i].trim().includes("_A"))){
                            banFec=false;
                        }
                        else{
                            banFec=true;
                        }
                    }
                    if (banFec){
                        fechas.push(fc + "*");
                        contfec++;
                    }
                    else{
                        fechas.push(fc);  
                    }
                })
                if (contfec===r.fechas.length){
                    r.mostrar=false;
                }
                r.fechas= fechas;
            })
            resTemp.map((r)=>{
               if (r.fechas.length>0){
                let finFec= r.fechas.filter((fc)=> !fc.includes("*"));
                r.fecha= finFec[0].substring(0,10);
               }
               else{
                r.fecha="31/12/3000";
               }
            })
            resTemp = resTemp.sort((a,b)=> new Date(...a.fecha.split('/').reverse()) - new Date(...b.fecha.split('/').reverse()));
            setFeeds(resTemp);
            //Publicaciones del día
          //  setFeedsDia(resTemp2);
            console.log(resTemp);
            setLoading(false);
        }
        catch(error){
            console.log(error)
        }
      }
      obtenerDatos();
    },[window.location.pathname]);

    return(
        <>
        <div id="Encabezado" data-english="1" data-temselec="2"></div>
        <div className="container">
        <div className="row">
            <div className="col-md-12 pad-left0">
            <div role="navigation" className="divNav" tabIndex="51">
                <a href="/default.html" tabIndex="52" >{idioma[5]?.desc}</a>&nbsp;/&nbsp; 
                <a href="/siscon" tabIndex="53" >{idioma[6]?.desc}</a>&nbsp;/&nbsp;
                <a href="/servicios/api_indicadores.html" tabIndex="53" >{idioma[7]?.desc}</a>&nbsp;/&nbsp;{idioma[0]?.desc}
            </div>
            </div>
        </div>
        </div>
        <div className="container cont">
            <div className="row">
                <div className="col-sm-12">
                    <div className="row con_desf_inf ">
                        <p className="text-right">
                            <a href="/servicios/api_indicadores.html">
                            <button type="button" className="close btnClose"  data-toggle="tooltip"  data-placement="top" title="Cerrar">
                            <span aria-hidden="true" className="imgX">×</span>
                            </button>
                            </a>
                        </p>
                        <h4>
                            {idioma[0]?.desc}
                        </h4>
                    <div className="pad10">
                        <div className="padB15">
                            {idioma[1]?.desc} (<a href={rutadoc + "calendario.xml"}>{idioma[8]?.desc}</a>)
                        </div>
                        {/* publicaciones del día */}
                        {/* <div className="divSepara">
                            {idioma[9]?.desc}
                        </div> */}
                         {/*Ponerlo en el null de feedsDia <div>{idioma[11]?.desc}</div> */}
                        { 
                            feedsDia?.length>0?
                                <div className="tab-content">
                                    <div className="table-responsive">
                                        <table className="table
                                                    table-bordered
                                                    table-condensed
                                                    table-hover
                                                    table-striped" >
                                        <thead> 
                                            <tr key={"cl1"}>
                                            {fila1?.map((cl,index)=>(
                                                index<=1?
                                                <th key={"cls" + index.toString()} rowSpan={cl.rowspan} className="col1">
                                                    {index===0? 
                                                        <> {cl.col} (<a href={rutadoc + cl.doc + ".xml"}>{cl.doc + ".xml"}</a>)</>
                                                        :
                                                        <> {cl.col} </>
                                                    }
                                                </th>
                                                :
                                                    index===2 || index===3
                                                    ?
                                                        <th key={"cls" + index.toString()} colSpan={cl.colspan} className="col2">
                                                            {cl.col }
                                                        </th>
                                                    :
                                                        <th key={"cls" + index.toString()} className="col1">
                                                            {cl.col }
                                                        </th>
                                            ))}
                                            </tr>
                                            <tr key={"cl2"}>
                                                {fila2?.map((cln,index1)=>(
                                                    <th key={"cln" + index1.toString()} className="col1">
                                                        {cln.col }
                                                    </th>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                        {
                                           feedsDia?.map((fd,index)=>(
                                                <tr key={"fd" + index.toString()}>
                                                    <td>{fd.indicador}
                                                    {/*  {servpreprod!=="prod" && fd?.fechas.length >0? */}
                                                            {fd?.fechas.length>0? 
                                                                <div>{idioma[4]?.desc}</div>
                                                            :null
                                                            }
                                                            {fd?.fechas.map((fe,indexfe)=>(
                                                                fe.includes("*")? 
                                                                null 
                                                                :
                                                                    <div key={"fe" + indexfe.toString()}>
                                                                        <span className="inegi-calendario"></span>
                                                                        <span className="font-b">{fe.substring(0,10)} </span>
                                                                        {fe.substring(10,12)!=="||"?
                                                                            <span> - {fe.substring(11,fe.indexOf("|",12))}</span>
                                                                        :
                                                                            null
                                                                        }
                                                                    </div>
                                                            ))}
                                                        {/* :
                                                            null
                                                        } */}
                                                    </td>
                                                    <td>{fd.periodicidad}</td>
                                                    <td>
                                                        {fd.ultimo_dato.nemonico_cifras_originales!==null && fd.ultimo_dato.nemonico_cifras_originales!==""?
                                                        <div>
                                                            <a href={rutadoc + fd.ultimo_dato.nemonico_cifras_originales + ".xml"} target="_blank">
                                                            {fd.ultimo_dato.nemonico_cifras_originales + ".xml"}</a>
                        {                                     /* {servpreprod!=="prod"?*/}
                                                                <div>
                                                                    {idioma[2]?.desc} 
                                                                        <a href={rutaIndicadores + "?tm=3&ind=" +  fd.ultimo_dato.serie_cifras_originales} target="_blank">{fd.ultimo_dato.serie_cifras_originales}</a>
                                                                </div>
                                                                <div className={fd.ultimo_dato.serie_variacion!=="0"? "display-block":"display-none"}>
                                                                    {idioma[3]?.desc} 
                                                                    <a href={rutaIndicadores + "?tm=3&ind=" +  fd.ultimo_dato.serie_variacion} target="_blank"> {fd.ultimo_dato.serie_variacion}</a>
                                                                </div>
                                                            {/*   :
                                                                    null
                                                                } */}
                                                        </div>
                                                        :
                                                        ""
                                                        }
                                                    </td>
                                                    <td>
                                                        {fd.ultimo_dato.nemonico_cifras_desestacionalizadas!==null && fd.ultimo_dato.nemonico_cifras_desestacionalizadas!==""?
                                                        <div>
                                                            <a href={rutadoc + fd.ultimo_dato.nemonico_cifras_desestacionalizadas + ".xml"} target="_blank">
                                                            {fd.ultimo_dato.nemonico_cifras_desestacionalizadas + ".xml"}</a>
                                                            {/* {servpreprod!=="prod"? */}
                                                                <div>
                                                                    {idioma[2]?.desc} 
                                                                    <a href={rutaIndicadores + "?tm=3&ind=" +  fd.ultimo_dato.serie_cifras_desestacionalizadas} target="_blank"> {fd.ultimo_dato.serie_cifras_desestacionalizadas}</a>
                                                                </div>
                                                            {/* :
                                                                null
                                                                } */}
                                                        </div>
                                                            :
                                                                ""
                                                            }
                                                    </td>
                                                    <td>
                                                        {fd.ultimo_dato.nemonico_cifras_originales!==null && fd.ultimo_dato.nemonico_cifras_originales!==""? 
                                                            <a href={rutadoc + fd.ultimo_dato.nemonico_cifras_originales + "_H" + ".xml"} target="_blank">
                                                            {fd.ultimo_dato.nemonico_cifras_originales + "_H.xml"}</a>
                                                        :
                                                        ""
                                                        }
                                                    </td>
                                                    <td>
                                                        {fd.ultimo_dato.nemonico_cifras_desestacionalizadas!==null && fd.ultimo_dato.nemonico_cifras_desestacionalizadas!==""? 
                                                            <a href={rutadoc + fd.ultimo_dato.nemonico_cifras_desestacionalizadas + "_H" + ".xml"} target="_blank">
                                                            {fd.ultimo_dato.nemonico_cifras_desestacionalizadas + "_H.xml"}</a>
                                                        :
                                                        ""
                                                        }
                                                    </td>
                                                </tr>  
                                            ))
                                        }
                                        </tbody>
                                        </table>
                                    </div>
                                </div>
                            :
                            null                           
                        }
                        {/* próximas publicaciones */}
                        {/* <div className="divSepara">
                            {idioma[10]?.desc}
                        </div> */}
                        <div className="tab-content">
                            <div className="table-responsive">
                                <table className="table
                                            table-bordered
                                            table-condensed
                                            table-hover
                                            table-striped" >
                                <thead> 
                                    <tr key={"cl1"}>
                                    {fila1?.map((cl,index)=>(
                                        index<=1?
                                        <th key={"cls" + index.toString()} rowSpan={cl.rowspan} className="col1">
                                            {index===0? 
                                                <> {cl.col} (<a href={rutadoc + cl.doc + ".xml"}>{cl.doc + ".xml"}</a>)</>
                                                :
                                                <> {cl.col} </>
                                            }
                                        </th>
                                        :
                                            index===2 || index===3
                                            ?
                                                <th key={"cls" + index.toString()} colSpan={cl.colspan} className="col2">
                                                    {cl.col }
                                                </th>
                                            :
                                                <th key={"cls" + index.toString()} className="col1">
                                                    {cl.col }
                                                </th>
                                    ))}
                                    </tr>
                                    <tr key={"cl2"}>
                                        {fila2?.map((cln,index1)=>(
                                            <th key={"cln" + index1.toString()} className="col1">
                                                {cln.col }
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                {
                                    feeds?.map((fd,index)=>(
                                    fd?.mostrar? 
                                        <tr key={"fd" + index.toString()}>
                                            <td>{fd.indicador}
                                            {/*  {servpreprod!=="prod" && fd?.fechas.length >0? */}
                                                    {fd?.fechas.length>0? 
                                                        <div>{idioma[4]?.desc}</div>
                                                    :null
                                                    }
                                                    {fd?.fechas.map((fe,indexfe)=>(
                                                        fe.includes("*")? 
                                                        null 
                                                        :
                                                            <div key={"fe" + indexfe.toString()}>
                                                                <span className="inegi-calendario"></span>
                                                                <span className="font-b">{fe.substring(0,10)} </span>
                                                                {fe.substring(10,12)!=="||"?
                                                                    <span> - {fe.substring(11,fe.indexOf("|",12))}</span>
                                                                :
                                                                    null
                                                                }
                                                            </div>
                                                    ))}
                                                {/* :
                                                    null
                                                } */}
                                            </td>
                                            <td>{fd.periodicidad}</td>
                                            <td>
                                                {fd.ultimo_dato.nemonico_cifras_originales!==null && fd.ultimo_dato.nemonico_cifras_originales!==""?
                                                <div>
                                                    <a href={rutadoc + fd.ultimo_dato.nemonico_cifras_originales + ".xml"} target="_blank">
                                                    {fd.ultimo_dato.nemonico_cifras_originales + ".xml"}</a>
            {                                       /* {servpreprod!=="prod"?*/}
                                                        <div>
                                                            {idioma[2]?.desc} 
                                                                <a href={rutaIndicadores + "?tm=3&ind=" +  fd.ultimo_dato.serie_cifras_originales} target="_blank">{fd.ultimo_dato.serie_cifras_originales}</a>
                                                        </div>
                                                        <div className={fd.ultimo_dato.serie_variacion!=="0"? "display-block":"display-none"}>
                                                            {idioma[3]?.desc} 
                                                            <a href={rutaIndicadores + "?tm=3&ind=" +  fd.ultimo_dato.serie_variacion} target="_blank"> {fd.ultimo_dato.serie_variacion}</a>
                                                        </div>
                                                {/*   :
                                                        null
                                                    } */}
                                                </div>
                                                :
                                                ""
                                                }
                                            </td>
                                            <td>
                                                {fd.ultimo_dato.nemonico_cifras_desestacionalizadas!==null && fd.ultimo_dato.nemonico_cifras_desestacionalizadas!==""?
                                                <div>
                                                    <a href={rutadoc + fd.ultimo_dato.nemonico_cifras_desestacionalizadas + ".xml"} target="_blank">
                                                    {fd.ultimo_dato.nemonico_cifras_desestacionalizadas + ".xml"}</a>
                                                    {/* {servpreprod!=="prod"? */}
                                                        <div>
                                                            {idioma[2]?.desc} 
                                                            <a href={rutaIndicadores + "?tm=3&ind=" +  fd.ultimo_dato.serie_cifras_desestacionalizadas} target="_blank"> {fd.ultimo_dato.serie_cifras_desestacionalizadas}</a>
                                                        </div>
                                                    {/* :
                                                    null
                                                    } */}
                                                </div>
                                                    :
                                                    ""
                                                    }
                                            </td>
                                            <td>
                                                {fd.ultimo_dato.nemonico_cifras_originales!==null && fd.ultimo_dato.nemonico_cifras_originales!==""? 
                                                    <a href={rutadoc + fd.ultimo_dato.nemonico_cifras_originales + "_H" + ".xml"} target="_blank">
                                                    {fd.ultimo_dato.nemonico_cifras_originales + "_H.xml"}</a>
                                                :
                                                ""
                                                }
                                            </td>
                                            <td>
                                                {fd.ultimo_dato.nemonico_cifras_desestacionalizadas!==null && fd.ultimo_dato.nemonico_cifras_desestacionalizadas!==""? 
                                                    <a href={rutadoc + fd.ultimo_dato.nemonico_cifras_desestacionalizadas + "_H" + ".xml"} target="_blank">
                                                    {fd.ultimo_dato.nemonico_cifras_desestacionalizadas + "_H.xml"}</a>
                                                :
                                                ""
                                                }
                                            </td>
                                        </tr>  
                                    :null
                                    ))
                                }
                                </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
        </>
    )
    
}